import { render } from "./ChangeRequestForm.vue?vue&type=template&id=5b7a957b"
import script from "./ChangeRequestForm.vue?vue&type=script&lang=js"
export * from "./ChangeRequestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__